import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main-header--menu-items" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "main-header--menu-item_title" }
const _hoisted_4 = { class: "caption-navbar main-header--menu-item_text" }


import BaseIcon from "@/components/base/BaseIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'NavBar',
  props: {
  menuItems: {
    type: Array as () => {
      title: string;
      icon: string;
      active: boolean;
      page: string;
    }[],
    required: true,
  },
},
  emits: ["change-menu"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const changeMenu = (index: number) => {
  emit("change-menu", index);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menuItems, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["main-header--menu-item", item.active ? 'active' : '']),
        onClick: ($event: any) => (changeMenu(index))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["main-header--menu-item_icon", { '--active': item.active }])
        }, [
          _createVNode(BaseIcon, {
            name: item.icon
          }, null, 8, ["name"])
        ], 2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(item.title), 1)
        ])
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})